<section class="crosswalk">
  <h2 class="page-heading">RPL to CCSA Mappings</h2>
  <p class="page-subheading">Reference Price List (RPL) to Complete CPT for South Africa (CCSA)</p>

  <p *ngIf="error" role="alert" class="error">{{ error }}</p>

  <div class="flex justify-between items-center toolbar">
    <form class="flex search-form" (ngSubmit)="load(true)">
      <mat-form-field>
        <mat-label>Search RPL, ICD or CCSA code</mat-label>
        <input matInput name="search" [(ngModel)]="search">
      </mat-form-field>
      <button class="search-button" mat-raised-button type="submit" [disabled]="loading">Search</button>
    </form>

    <button *ngIf="canEdit" mat-raised-button color="accent" type="button" (click)="openDialog()">
      <mat-icon>add</mat-icon>
      Add Mapping
    </button>
  </div>

  <section class="mat-elevation-z8 table-container" [attr.aria-busy]="loading">
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows>
      <ng-container [matColumnDef]="tableColumns.Actions">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell>
          <button mat-icon-button color="primary" class="edit-button" type="button"
                  (click)="$event.stopPropagation(); openDialog(row)"
                  matTooltip="Edit mapping" [attr.aria-label]="'Edit mapping for RPL ' + row.rplCode">
            <mat-icon class="edit-icon">edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Rpl">
        <th *matHeaderCellDef mat-header-cell>Reference Price List (RPL)</th>
        <td *matCellDef="let row" mat-cell>
          <strong>{{ row.rplCode }}</strong>
          <div class="cell-description" [matTooltip]="row.rplDescription"
               [matTooltipDisabled]="!row.rplDescription">{{ row.rplDescription || '—' }}</div>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Diagnosis">
        <th *matHeaderCellDef mat-header-cell>Primary ICD-10 Diagnosis</th>
        <td *matCellDef="let row" mat-cell>
          <strong>{{ row.primaryDiagnosisCode }}</strong>
          <div class="cell-description" [matTooltip]="row.diagnosisDescription"
               [matTooltipDisabled]="!row.diagnosisDescription">{{ row.diagnosisDescription || '—' }}</div>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Ccsa">
        <th *matHeaderCellDef mat-header-cell>Complete CPT for South Africa (CCSA)</th>
        <td *matCellDef="let row" mat-cell>
          <strong *ngIf="row.ccsaCode">{{ row.ccsaCode }}</strong>
          <span *ngIf="!row.ccsaCode">No equivalent</span>
          <div *ngIf="row.ccsaDescription" class="cell-description" [matTooltip]="row.ccsaDescription">
            {{ row.ccsaDescription }}
          </div>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Age">
        <th *matHeaderCellDef mat-header-cell>Age</th>
        <td *matCellDef="let row" mat-cell>{{ ageDescription(row) }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Status">
        <th *matHeaderCellDef mat-header-cell>Status</th>
        <td *matCellDef="let row" mat-cell>
          <div class="flex items-center status-cell">
            <greydom-status-indicator [fillColor]="statusColor(row)"></greydom-status-indicator>
            <span class="m-l-5">{{ statusDescription(row) }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" [attr.colspan]="displayedColumns.length" mat-cell>
          <div [@detailExpand]="row === expandedElement ? 'expanded' : 'collapsed'"
               class="row-detail-container">
            <div class="audit-details">
              <div class="audit-notes"><span class="audit-label">Notes:</span> {{ row.notes || '—' }}</div>
              <div><span class="audit-label">Created By:</span> {{ row.createdBy || '—' }}</div>
              <div><span class="audit-label">Created Date:</span> {{ row.created ? (row.created | date:'yyyy-MM-dd HH:mm') : '—' }}</div>
              <div><span class="audit-label">Updated By:</span> {{ row.updatedBy || '—' }}</div>
              <div><span class="audit-label">Updated Date:</span> {{ row.updated ? (row.updated | date:'yyyy-MM-dd HH:mm') : '—' }}</div>
            </div>
          </div>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" class="row"
          [class.expanded-row]="expandedElement === row"
          [attr.aria-expanded]="expandedElement === row"
          tabindex="0" mat-row
          (click)="toggleExpanded(row)"
          (keydown)="handleRowKeydown($event, row)"></tr>
      <tr *matRowDef="let row; columns: ['expandedDetail']" class="detail-row" mat-row></tr>
      <tr *matNoDataRow class="mat-row">
        <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
          {{ loading ? 'Loading mappings…' : 'No mappings found.' }}
        </td>
      </tr>
    </table>

    <mat-paginator [length]="total" [pageIndex]="pageIndex" [pageSize]="pageSize"
                   [pageSizeOptions]="[25, 50, 100]" [disabled]="loading"
                   (page)="page($event)" aria-label="Mapping pages">
    </mat-paginator>
  </section>
</section>
